import React from "react";

// utils
import { getIsAITutorModalitiesEnabled } from "Utils/ACLStoreUtils";

// components
import AITutor from "../AITutor";
import AITutorV2 from "../AITutorV2";
import Worksheet from "Worksheet";

// constants
import {
  MODE_TEACHER_CREATE,
  ASSESSMENT_TYPE_WORKSHEET,
} from "Worksheet/modules/WorksheetConstants";
import {
  ASSESSMENT_TYPE_AI_TUTOR,
  TASK_TYPE_AI_TUTOR,
  TASK_TYPE_WORKSHEET,
} from "Constants/stringConstants";

// modules
import { ResourceDetailsContext } from "UnitPlans/modules/UnitPlanModule";

const WithMiddlePaneHOC = Component => {
  const WrappedComponent = props => {
    const {
      assessmentType,
      taskTypeGroup,
      parentType,
      resourceId /* assessmentId */,
      sourceFrom,
      courseId,
      unitPlanId,
      middlePaneRef,
      isFromInitializingModal,
    } = props;

    // Check both assessmentType and taskTypeGroup for AI Tutor
    const isAITutorAssessment =
      assessmentType === ASSESSMENT_TYPE_AI_TUTOR ||
      taskTypeGroup === TASK_TYPE_AI_TUTOR;

    // Check both assessmentType and taskTypeGroup for Worksheet
    const isWorksheetAssessment =
      assessmentType === ASSESSMENT_TYPE_WORKSHEET ||
      taskTypeGroup === TASK_TYPE_WORKSHEET;

    if (isAITutorAssessment) {
      const WrappedAITutor = getIsAITutorModalitiesEnabled()
        ? AITutorV2
        : AITutor;

      return (
        <WrappedAITutor {...props}>
          <Component {...props} />
        </WrappedAITutor>
      );
    }

    if (isWorksheetAssessment) {
      return !isFromInitializingModal ? (
        <ResourceDetailsContext.Consumer>
          {assessmentDetailsProps => {
            const {
              creationMode,
              isFromUnitPlan,
              isDraft,
              courseSubjects,
              onWorksheetDoneClick,
              defaultQuestionIds,
              selectedCourse,
              courseGrades,
              setWorksheetRef,
            } = assessmentDetailsProps;

            return (
              <Worksheet
                mode={MODE_TEACHER_CREATE}
                parentId={resourceId}
                parentType={parentType}
                setWorksheetRef={setWorksheetRef}
                courseGrades={courseGrades}
                onWorksheetDoneClick={onWorksheetDoneClick}
                courseSubjects={courseSubjects}
                defaultQuestionIds={defaultQuestionIds}
                portalType={"PLANNER"}
                assessmentDetailsComponent={<Component {...props} />}
                worksheetDetailsRef={middlePaneRef}
                sourceFrom={sourceFrom}
                creationMode={creationMode}
                courseId={courseId}
                selectedCourse={selectedCourse}
                unitPlanId={unitPlanId}
                isFromUnitPlan={isFromUnitPlan}
                isDraft={isDraft}
              />
            );
          }}
        </ResourceDetailsContext.Consumer>
      ) : (
        <Component {...props} />
      );
    }

    return <Component {...props} />;
  };

  return WrappedComponent;
};

export default WithMiddlePaneHOC;
